module.exports = __webpack_public_path__ + "static/media/stat4.15a86910.png";